import React, { useState, useEffect } from "react";
import { Button } from "@heroui/react";
import ResultTable from "./ResultTable";
import ResultForm from "./ResultForm";
import { Spinner } from "@heroui/react";
const MatchResults = () => {
  const [results, setResults] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: "", status: "active" });
  const [selectedRows, setSelectedRows] = useState({
    row1: false,
    row2: false,
    row3: false,
    row4: false,
    row5: false,
    row11: false,
    row22: false,
  });
  const [disabledRows, setDisabledRows] = useState({
    row1: false,
    row2: false,
    row3: false,
    row4: false,
    row5: false,
    row11: false,
    row22: false,
  });
  const [inputValues, setInputValues] = useState({
    single: { open: "", openres:"", close: "", closeres:"", mmid: -1 },
    singlePatti: { open: "", close: "", mmid: -1 },
    doublePatti: { open: "", close: "", mmid: -1 },
    triplePatti: { open: "", close: "", mmid: -1 },
    jodi: { open: "", close: "", mmid: -1 },
  });
  const [selectedMarketId, setSelectedMarketId] = useState("");
  const [selectedMatchName, setSelectedMatchName] = useState("");
  const [resultDetails, setResultDetails] = useState([]);
  const getAdminDashboardResultsList = async () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
    const userId = localStorage.getItem("uid");
    const url = process.env.REACT_APP_API_HOST + `/results?user_id=${userId}`;
    const requestOptions = {
      method: "GET",
      headers: headers,
    };
    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          setResults(result.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching events:", err);
      });
  };
  useEffect(() => {
    getAdminDashboardResultsList();
  }, []);
  const [marketData, setMarketData] = useState([]);
  const [selectedMatchId, setSelectedMatchId] = useState("");
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const formatMarketData = (rawData) => {
    const marketMap = {};
    rawData.forEach((item) => {
      const { market_id, marketname, matchname, match_id, draw_date } = item;
      if (!marketMap[market_id]) {
        marketMap[market_id] = {
          id: market_id,
          name: marketname,
          matches: [],
        };
      }
      marketMap[market_id].matches.push({
        id: match_id,
        name: matchname,
        draw_date: draw_date,
      });
    });
    return Object.values(marketMap);
  };
  const getAdminDashboardResults = async (e) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
    const urlencoded = {
      user_id: localStorage.getItem("uid"),
    };
    let requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(urlencoded),
    };
    fetch(process.env.REACT_APP_API_HOST + "/getMarketById", requestOptions)
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          const formatted = formatMarketData(result.data);
          setMarketData(formatted);
        }
      })
      .catch((err) => {
        console.log("Error fetching results:", err);
      })
      .finally(() => {});
  };
  useEffect(() => {
    getAdminDashboardResults();
  }, []);
  useEffect(() => {
    if (showForm) {
      const mainContainer = document.querySelector("main");
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }, [showForm]);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const isEditing = !!formData.id;
    const updatedResults = isEditing
      ? results.map((m) => (m.id === formData.id ? formData : m))
      : [...results, { ...formData, id: results.length + 1 }];
    setResults(updatedResults);
    setShowForm(false);
    setFormData({ name: "", status: "active" });
  };
  const handleEdit = (result, mid, mode) => {
    const mainContainer = document.querySelector("main");
    if (mainContainer) {
      mainContainer.scrollTo({ top: 0, behavior: "smooth" });
    }
    setLoading(true);
    setShowForm(true);
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
    const urlencoded = {
      user_id: localStorage.getItem("uid"),
      result_id: result.id,
    };
    let requestOptions = {
      method: "GET",
      headers: headers,
    };
    fetch(process.env.REACT_APP_API_HOST + "/getResultById", requestOptions)
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          // console.log("Fetched result by ID:", result.data);
          setFormData({
            ...formData,
            id: result.data.id,
            market_id: result.data.market_id,
            marketname: result.data.marname,
            matchname: result.data.matname,
            matchtype: result.data.matchtype,
            open_result: result.data.open_result,
            close_result: result.data.close_result,
            match_id: result.data.match_id,
            matchDate: result.data.draw_date,
            status: result.data.status,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error fetching results:", err);
      })
      .finally(() => {});
  };
  const handleDelete = (id, mode) => {
    setTimeout(() => {
      const mainContainer = document.querySelector("main");
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 100);
    setLoading(true);
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
    const urlencoded = {
      user_id: localStorage.getItem("uid"),
      match_id: id,
    };
    let requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(urlencoded),
    };
    fetch(process.env.REACT_APP_API_HOST + "/getMatchTypeId", requestOptions)
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          const map = {};
          result.data.forEach((item) => {
            map[item.type_id] = item;
          });
          // console.log("Fetched match types:", map);

          // let open3Digit = null;
          // let close3Digit = null;

          // for (const item of result.data) {
          //   if (
          //     !open3Digit &&
          //     item.open_result &&
          //     item.open_result.length === 3
          //   ) {
          //     open3Digit = item.open_result;
          //   }
          //   if (
          //     !close3Digit &&
          //     item.close_result &&
          //     item.close_result.length === 3
          //   ) {
          //     close3Digit = item.close_result;
          //   }

          //   // Break early if both found
          //   if (open3Digit && close3Digit) break;
          // }

          // console.log("Open 3-digit Result:", open3Digit); // e.g., "123"
          // console.log("Close 3-digit Result:", close3Digit); // if available

          // console.log("Result data MAP:", map);

          setResultDetails(map);
          setSelectedMarketId(result.data[0].market_id);
          setSelectedMatchName(result.data[0].match_id);
          setFormData({
            ...formData,
            mode: mode,
            id: result.data[0].match_id,
            market_id: result.data.market_id,
            marketname: result.data[0].marketname,
            matchname: result.data[0].match_title,
            matchtype: result.data.matchtype,
            open_result: result.data.open_result,
            close_result: result.data.close_result,
            match_id: result.data.match_id,
            matchDate: result.data[0].matchdate,
            status: result.data.status,
          });
          setLoading(false); // Stop loader
          setShowForm(true);
        }
      })
      .catch((err) => {
        console.log("Error fetching results:", err);
      })
      .finally(() => {});
  };
  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner size="lg" variant="spinner" color="warning" />
      </div>
    );
  }
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-900">Results</h2>
        <Button
          color="primary"
          className="bg-admin_black text-white"
          onClick={() => {
            setShowForm(!showForm);
            setSelectedMarketId("");
            setSelectedMatchName("");
            setSelectedMatchId("");
            setMatches([]);
            setResultDetails([]);
            setInputValues({
              single: { open: "", openres:"", close: "", closeres:"", mmid: -1 },
              singlePatti: { open: "", close: "", mmid: -1 },
              doublePatti: { open: "", close: "", mmid: -1 },
              triplePatti: { open: "", close: "", mmid: -1 },
              jodi: { open: "", close: "", mmid: -1 },
            });
            setDisabledRows({
              row1: false,
              row2: false,
              row3: false,
              row4: false,
              row5: false,
              row11: false,
              row22: false,
            });
            setSelectedRows({
              row1: false,
              row2: false,
              row3: false,
              row4: false,
              row5: false,
              row11: false,
              row22: false,
            });
            setFormData({ mode: "Add", name: "", status: "active" });
          }}
        >
          {showForm ? "Cancel" : "Add Result"}
        </Button>
      </div>

      {showForm && (
        <ResultForm
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          onCancel={() => setShowForm(false)}
          marketData={marketData}
          setMarketData={setMarketData}
          getAdminDashboardResultsList={getAdminDashboardResultsList}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          disabledRows={disabledRows}
          setDisabledRows={setDisabledRows}
          inputValues={inputValues}
          setInputValues={setInputValues}
          resultDetails={resultDetails}
          setResultDetails={setResultDetails}
          selectedMarketId={selectedMarketId}
          setSelectedMarketId={setSelectedMarketId}
          selectedMatchName={selectedMatchName}
          setSelectedMatchName={setSelectedMatchName}
        />
      )}
      <ResultTable
        results={results}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};
export default MatchResults;
